



























import { mapActions, mapGetters } from 'vuex';

import { DistributionChart, KpisSuccess, Pivots, UiProgressLinear } from '../components';

import { ApiEnum, KpiEnum } from '../enums';

import { AnalyticsMixin } from '../mixins/analytics.mixin';

import { ANALYTICS_CONSTS } from '../store/analytics/analytics.consts';
import { CONFIG_CONSTS } from '../store/config/config.consts';

export default {
  name: 'overall',
  mixins: [AnalyticsMixin],
  components: {
    KpisSuccess,
    DistributionChart,
    Pivots,
    UiProgressLinear
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      kpis: CONFIG_CONSTS.getters.kpis
    })
  },
  data: function () {
    return {
      loading: {
        distribution: false
      },
      messages: this.$epb.messages.analytics
    };
  },
  methods: {
    ...mapActions(ANALYTICS_CONSTS.moduleName, {
      loadDistData: ANALYTICS_CONSTS.actions.loadDistData,
      loadSessionsData: ANALYTICS_CONSTS.actions.loadSessionsData
    }),
    loadData: async function (): Promise<void> {
      this.loading.distribution = true;
      try {
        await this.loadDistData();
        if (this.kpis.includes(KpiEnum.SESSIONS) || this.kpis.includes(KpiEnum.QUERIES_PER_SESSION)) {
          await this.loadSessionsData();
        }
      } catch (error) {
        this.$emit('showError', this.$epb.utils.decodeErrorMessage(error, ApiEnum.STATS));
      } finally {
        this.loading.distribution = false;
      }
      await this.$refs.pivotsComponent.loadData();
    }
  }
};

